import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { SCHEMA_LAYOUT_TYPES } from '@cli-constants/schema.js'

export function isPersistedSchemaField(field: SchemaField): boolean {
  return !SCHEMA_LAYOUT_TYPES.has(field.type)
}
